import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Calculations, CalculationState, selectCalculations } from '../../calculation.state';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { CalculationsService } from '../../../../api/services/calculations.service';
import { CalculationTypeEnum } from '../../../../api/models/calculation-type-enum';

@Component({
  selector: 'roof-sketches',
  templateUrl: './sketches.component.html',
  styleUrls: ['./sketches.component.scss'],
})
export class SketchesComponent implements OnInit, OnDestroy {
  form!: UntypedFormGroup;
  private stateSubscription!: Subscription;
  sketches!: Observable<string[]>;
  private calculations!: Calculations;

  constructor(private store: Store<AppState>, private readonly calculationsService: CalculationsService) {}

  async ngOnInit(): Promise<void> {
    this.stateSubscription = this.store
      .pipe(map((state) => selectCalculations(state)))
      .subscribe(async (calculations) => {
        const activeTab = calculations.activeTab;
        const activeCalculation = calculations[activeTab];
        if (calculations.stepperStep !== 3 || !calculations.models?.roof?.id || !activeCalculation) {
          return;
        }
        if (this.hasChanges(calculations)) {
          this.calculations = calculations;
          this.sketches = this.getSketches(activeTab, activeCalculation).pipe(
            map((res: any) => {
              return res?.sketches?.map((sketch: string) => 'data:image/jpeg;base64,' + sketch);
            }),
            catchError(() => {
              return [];
            }),
            shareReplay(1),
          );
        }
      });
  }

  hasChanges(calculations: Calculations) {
    if (!this.calculations) {
      return true;
    }
    const activeTab = calculations.activeTab;
    const activeCalculation = calculations[activeTab];
    if (calculations.models?.roof.id !== this.calculations.models?.roof.id) {
      return true;
    }
    if (
      JSON.stringify(activeCalculation.measurements) !==
      JSON.stringify(this.calculations[calculations.activeTab].measurements)
    ) {
      return true;
    }
    return (
      JSON.stringify(activeCalculation.annexes) !== JSON.stringify(this.calculations[calculations.activeTab].annexes)
    );
  }

  getSketches(activeTab: CalculationTypeEnum, activeCalculation: CalculationState) {
    // this.progressSpinnerService.openProgressSpinner();
    const body = {
      roofColorId: this.calculations.models?.color.id as string,
      annexes: activeCalculation.annexes,
      accessories: [],
      hasDripStop: this.calculations.models?.hasDripStop || false,
    };

    return this.calculationsService.calculationsControllerGenerateSketches({
      roofType: activeTab,
      body: {
        ...body,
        measurements: activeCalculation.measurements as any,
      },
    });
  }

  ngOnDestroy() {
    this.stateSubscription?.unsubscribe();
  }
}
